import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FragrancesHero from './components/FragrancesHero';
import CategoryCard from './components/CategoryCard';

const categories = [
  {
    title: 'Alta Perfumería',
    description: 'Insumos para perfumes y colonias de lujo elaborados con los mejores ingredientes.',
    imageUrl:
      'https://readdy.ai/api/search-image?query=luxury%20crystal%20perfume%20bottle%20with%20golden%20amber%20liquid%20on%20dark%20reflective%20surface%20surrounded%20by%20scattered%20rose%20petals%20and%20vanilla%20pods%20dramatic%20studio%20lighting%20deep%20shadows%20warm%20tones%20high-end%20fragrance%20editorial%20photography%20dark%20moody%20background&width=800&height=500&seq=cat-alta-perfumeria&orientation=landscape',
  },
  {
    title: 'Frascos para Perfumería',
    description: 'Envases de vidrio de alta calidad para perfumes, colonias y fragancias exclusivas.',
    imageUrl:
      'https://readdy.ai/api/search-image?query=collection%20of%20luxury%20empty%20glass%20perfume%20bottles%20in%20different%20elegant%20shapes%20and%20sizes%20arranged%20on%20dark%20reflective%20surface%20with%20soft%20warm%20lighting%20crystal%20clear%20and%20amber%20glass%20high-end%20packaging%20design%20dark%20moody%20background%20professional%20product%20photography&width=800&height=500&seq=cat-frascos-perfumeria&orientation=landscape',
  },
  {
    title: 'Insumos para Perfumería Fina',
    description: 'Materias primas exclusivas, aceites esenciales y extractos para crear fragancias únicas.',
    imageUrl:
      'https://readdy.ai/api/search-image?query=premium%20perfume%20raw%20materials%20amber%20glass%20bottles%20with%20essential%20oils%20dried%20botanicals%20vanilla%20pods%20sandalwood%20cinnamon%20sticks%20on%20dark%20wooden%20surface%20warm%20candlelight%20artisan%20perfumery%20ingredients%20dark%20moody%20background%20professional%20editorial%20photography&width=800&height=500&seq=cat-insumos-perfumeria&orientation=landscape',
  },
  {
    title: 'Ambientadores',
    description: 'Fragancias ambientales para velas, difusores y sprays de habitación.',
    imageUrl:
      'https://readdy.ai/api/search-image?query=elegant%20scented%20candles%20and%20reed%20diffusers%20on%20dark%20reflective%20surface%20with%20soft%20smoke%20wisps%20dried%20eucalyptus%20branches%20golden%20warm%20candlelight%20luxury%20home%20fragrance%20collection%20dark%20sophisticated%20atmosphere%20professional%20editorial%20photography&width=800&height=500&seq=cat-ambientadores&orientation=landscape',
  },
];

export default function Fragrances() {
  return (
    <div className="relative">
      <Navbar />
      <main>
        {/* Page Header */}
        <FragrancesHero />

        {/* Content */}
        <section className="py-20 md:py-28 px-6 md:px-16 lg:px-24 bg-stone-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
              Insumos que transforman cada creación en un recuerdo
            </h2>
            <p className="text-gray-600 leading-relaxed mb-8">
              Selección premium de materias primas importadas para quienes no se conforman con lo ordinario.
            </p>
            <p className="text-gray-600 leading-relaxed mb-8">
              Ofrecemos soluciones de abastecimiento personalizadas a precios competitivos, combinando calidad y precisión para satisfacer sus necesidades únicas. Nuestro equipo de especialistas en insumos trabaja codo a codo con los clientes para garantizar materiales exclusivos que cautivan e inspiran.
            </p>
            <p className="text-gray-600 leading-relaxed mb-8">
              Desde el pedido hasta la entrega final, le acompañamos en cada paso del proceso logístico. Nuestra red de distribución de última generación y nuestra extensa biblioteca de materias primas nos permiten abastecer proyectos de alta perfumería, frascos para perfumería, insumos de perfumería fina y ambientadores.
            </p>

            {/* Categories Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-12">
              {categories.map((cat) => (
                <CategoryCard
                  key={cat.title}
                  title={cat.title}
                  description={cat.description}
                  imageUrl={cat.imageUrl}
                />
              ))}
            </div>

            {/* Download Catalog CTA */}
            <div className="mt-16 md:mt-20 text-center">
              <div className="w-12 h-px bg-gray-400 mx-auto mb-8" />
              <p className="text-gray-600 text-sm md:text-base mb-6 max-w-lg mx-auto leading-relaxed">
                Descubre nuestra colección completa de fragancias, insumos y envases.
              </p>
              <a
                href="https://storage.readdy-site.link/project_files/9df4a25d-3a45-400e-b6ef-a6922afe5ed4/96681465-bbe9-46e7-8ab0-8e4aba3c43ef_CATALOGO-FRAGANCIAS-ESENCIACO.xlsx?v=d612a887a924c9a6f7c0f440d7d9e59c"
                download
                className="inline-flex items-center gap-3 px-10 py-4 border border-gray-400 text-gray-900 text-sm tracking-widest uppercase transition-all duration-300 hover:bg-gray-900 hover:text-white hover:border-gray-900 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-line text-base" />
                Descargar Catálogo
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}